// extracted by mini-css-extract-plugin
export var bodyFont = "index-module--body-font--ym-Gg";
export var borderRadius = "index-module--border-radius--PlIXq";
export var clearButtonStyles = "index-module--clear-button-styles--zdcHE";
export var inline = "index-module--inline--BzmF1";
export var team_size_ul = "index-module--team_size_ul--VlwvV";
export var titleFont = "index-module--title-font--JB0sb";
export var ts_wrapper = "index-module--ts_wrapper--c8oop";